module.exports = __webpack_public_path__ + "static/media/dpd.e97688f4.png";